import axios from "../plugins/parseAxios";
export class CustomerUserAPI {
  constructor(props) { }
  static getCustomerUserByProject(payload, user) {
    return axios.post("functions/getCustomerUserByProject", payload, user);
  }
}
